"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    width: "25",
    height: "25"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.5,25C5.6,25,0,19.4,0,12.5S5.6,0,12.5,0S25,5.6,25,12.5S19.4,25,12.5,25z M12.5,1C6.2,1,1,6.2,1,12.5S6.2,24,12.5,24 S24,18.8,24,12.5S18.8,1,12.5,1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.4,20.1c-4.2,0-7.5-3.4-7.5-7.5S11.2,5,15.4,5c1.2,0,2.4,0.3,3.5,0.8c0.4,0.2,0.5,0.6,0.3,1c-0.2,0.4-0.6,0.5-1,0.3 c-0.9-0.4-1.8-0.7-2.8-0.7c-3.3,0-6,2.7-6,6c0,3.3,2.7,6,6,6c1,0,2-0.3,2.9-0.7c0.4-0.2,0.8-0.1,1,0.3c0.2,0.4,0.1,0.8-0.3,1 C17.9,19.8,16.6,20.1,15.4,20.1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.5,9.4c-1.2,0-2.2-1-2.2-2.2S5.2,5,6.5,5c1.2,0,2.2,1,2.2,2.2S7.7,9.4,6.5,9.4z M6.5,6.3C6,6.3,5.5,6.7,5.5,7.2 S6,8.1,6.5,8.1c0.5,0,0.9-0.4,0.9-0.9S7,6.3,6.5,6.3z"
  }));
};

exports["default"] = _default;